export const optionsNotGoingToBeIn = [
  'Front Porch',
  'Back Porch',
  'Garage',
  'Shed/Greenhouse/Outbuilding',
  'Conservatory',
  'Neighbour',
  'Other',
]

export const fieldsEditAddress = [
  { name: 'name', placeholder: 'Name (e.g. Home, Work)' },
  { name: 'line1', placeholder: 'Address Line 1' },
  { name: 'line2', placeholder: 'Address Line 2' },
  { name: 'line3', placeholder: 'Address Line 3' },
  { name: 'town', placeholder: 'Town' },
  { name: 'county', placeholder: 'County' },
]
